

import '../../../App'

import Header from '../../header/Header';
import Footer from '../../footer/Footer';
import Main from '../../main/Main';
const ProjectsMe = () => {
  
  return (
    <div className="container">
      <Header/>
      <div className='divider'></div>
    <Main/>
    <div className='divider'></div>
    <Footer/>
    </div>

   
  )
}

export default ProjectsMe



